import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlashSaleOrderSubmitted, OrderSubmitted } from "@faire/retailer-visitor-shared/events";
import { getFreeShippingStatuses } from "@faire/retailer-visitor-shared/serialized-data/getFreeShippingStatuses";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { useMutation as useFreeShippingStatusMutation } from "@faire/web-api--source/api/retailer/retailerToken/free-shipping-status/post-hooks";
import { FreeShippingReason } from "@faire/web-api--source/indigofair/data/FreeShippingReason";
import { IFreeShippingStatusRequest } from "@faire/web-api--source/indigofair/data/IFreeShippingStatusRequest";
import React, { useCallback, useEffect } from "react";
var DEFAULTS = {
    freeShippingStatuses: undefined,
    hasFreeShippingOnFirstOrder: false
};
var _createContextStore = createContextStore(DEFAULTS), useStore = _createContextStore.useStore, Provider = _createContextStore.Provider;
var Synchronizer = function() {
    var _useFreeShippingStatusMutation = useFreeShippingStatusMutation(), getFreeShippingStatus = _useFreeShippingStatusMutation.mutate;
    var _useRetailerStore = useRetailerStore([
        "retailerToken",
        "retailer"
    ]), retailerToken = _useRetailerStore.retailerToken, retailer = _useRetailerStore.retailer;
    var _useFreeShippingContextStore = _sliced_to_array(useFreeShippingContextStore([
        "freeShippingStatuses"
    ]), 2), freeShippingStatuses = _useFreeShippingContextStore[0].freeShippingStatuses, setFreeShippingContextStore = _useFreeShippingContextStore[1];
    var fetchFreeShippingStatus = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (retailerToken) {
                getFreeShippingStatus([
                    retailerToken,
                    IFreeShippingStatusRequest.build({})
                ], {
                    onSuccess: function(response) {
                        setFreeShippingContextStore({
                            freeShippingStatuses: response.statuses
                        });
                    },
                    onError: function() {
                        setFreeShippingContextStore({
                            freeShippingStatuses: undefined
                        });
                    }
                });
            }
            return [
                2
            ];
        });
    }), [
        getFreeShippingStatus,
        retailerToken,
        setFreeShippingContextStore
    ]);
    useEffect(function() {
        if (!retailer) {
            setFreeShippingContextStore({
                hasFreeShippingOnFirstOrder: false
            });
        } else {
            setFreeShippingContextStore({
                hasFreeShippingOnFirstOrder: Boolean(freeShippingStatuses === null || freeShippingStatuses === void 0 ? void 0 : freeShippingStatuses.find(function(s) {
                    return s.reason === FreeShippingReason.FIRST_ORDER_FREE_SHIPPING;
                }))
            });
        }
    }, [
        freeShippingStatuses,
        retailer,
        setFreeShippingContextStore
    ]);
    useEffect(function() {
        var globalShippingStatuses = getFreeShippingStatuses();
        if (globalShippingStatuses) {
            setFreeShippingContextStore({
                freeShippingStatuses: globalShippingStatuses
            });
        } else {
            fetchFreeShippingStatus();
        }
    }, [
        fetchFreeShippingStatus,
        setFreeShippingContextStore
    ]);
    useEffect(function() {
        OrderSubmitted.subscribe(fetchFreeShippingStatus);
        FlashSaleOrderSubmitted.subscribe(fetchFreeShippingStatus);
        // Cleanup subscriptions on unmount
        return function() {
            OrderSubmitted.unsubscribe(fetchFreeShippingStatus);
            FlashSaleOrderSubmitted.unsubscribe(fetchFreeShippingStatus);
        };
    }, [
        fetchFreeShippingStatus
    ]);
    return null;
};
var useFreeShippingContextStore = useStore;
var FreeShippingContextStoreProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(Provider, {
        children: [
            children,
            /*#__PURE__*/ _jsx(Synchronizer, {})
        ]
    });
};
export { useFreeShippingContextStore, FreeShippingContextStoreProvider };
